import { render, staticRenderFns } from "./VeranstaltungIcon.vue?vue&type=template&id=c9a3d9ba&scoped=true&"
import script from "./VeranstaltungIcon.vue?vue&type=script&lang=js&"
export * from "./VeranstaltungIcon.vue?vue&type=script&lang=js&"
import style0 from "./VeranstaltungIcon.vue?vue&type=style&index=0&id=c9a3d9ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a3d9ba",
  null
  
)

export default component.exports